export function waitForGTag(callback, attempts = 0) {
  const updatedAttempts = attempts + 1;

  if (updatedAttempts > 3) {
    return callback(false);
  } else if (window.gtag) {
    return callback(true);
  }

  return setTimeout(() => waitForGTag(callback, updatedAttempts), 500);
}

/* istanbul ignore next */
export function activateExperiment(name) {
  return new Promise((resolve, reject) => {
    window.gtag('event', 'optimize.activate');
    const timeout = setTimeout(() => {
      reject('Optimize callback timeout');
    }, 1000);

    window.gtag('event', 'optimize.callback', {
      name,
      callback: value => {
        clearTimeout(timeout);
        resolve(value);
      },
    });
  });
}
